module.exports = __webpack_public_path__ + "img/quotes-1.dc7741ff.png";